/*------------------------------------*\
    tooltip
\*------------------------------------*/
module.exports = function(){



    var initializeTooltips = function(){

        window.jBoxLatestTooltip = $('.js-tooltip').jBox('Tooltip', {
            constructOnInit: true,
            //position: {
            //    y: 'bottom'
            //},
            //offset: {
            //    x: -113,
            //    y: -10
            //},
            //theme: 'aform',
            //pointer: 'right:150',
            trigger: 'mouseenter',
            //closeOnClick: 'body',
            //fixed: true,
            adjustTracker: 'scroll',
            animation: {
                open: 'move',
                close: 'move'
            },
            maxWidth: 280,
            getContent: 'data-tooltip',

            onOpen: function() {
                this.target.addClass('is-active');
            },
            onClose: function() {
                this.target.removeClass('is-active');
            }

        });


    };


    initializeTooltips();




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/tooltip.js